import * as React from 'react';
import CalendarItemView from './CalendarItemView';
import TxpCalendarItemView from './TxpCalendarItemView';
import useCalendarItemViewState from '../utils/useCalendarItemViewState';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import type { CalendarItemPayload } from '../schema';
import { INVOICE_ENTITY_NAMES_MAP_VALUE } from 'owa-txp-common/lib/helpers/TxpCommonConstants';
import { isFeatureEnabled } from 'owa-feature-flags';
import { observer } from 'mobx-react-lite';

export default observer(function TxpOrCalendarItemView(
    props: AssetCommonViewProps<CalendarItemPayload>
) {
    const {
        item,
        fullItem,
        itemId,
        popoutPane,
        parsedStart,
        parsedEnd,
        notFound,
        isTXPView,
    } = useCalendarItemViewState(props);

    if (
        isTXPView &&
        fullItem?.EntityNamesMap &&
        isFeatureEnabled('outlookSpaces-txpView') &&
        item?.EntityNamesMap != INVOICE_ENTITY_NAMES_MAP_VALUE
        //this will ensure that emails with invoice data are shown in the original view
    ) {
        return (
            <TxpCalendarItemView
                item={item}
                fullItem={fullItem}
                popoutPane={popoutPane}
                DueDate={props.DueDate}
                assetColor={props.color}
            />
        );
    } else {
        return (
            <CalendarItemView
                item={item}
                itemId={itemId as string}
                popoutPane={popoutPane}
                parsedStart={parsedStart}
                parsedEnd={parsedEnd}
                notFound={notFound}
                DueDate={props.DueDate}
            />
        );
    }
});
